/* global axios */
import ApiClient from './ApiClient';

class WhatsappTemplatesAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // FormData: a criação pode levar o arquivo de exemplo do header de mídia.
  create(inboxId, formData) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_templates`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  sync(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }
}

export default new WhatsappTemplatesAPI();
